import { useParams, useRouter } from '@tanstack/react-router';
import { useFetchLane } from '@uturn/api/v1';
import { LoadingSpan, Page } from '@uturn/portal/components';
import { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { ContainerDetails } from '../components/details/container-details';
import { LaneDetailContext } from '../components/details/detail-context';
import { RouteDetails } from '../components/details/route-details';
import { ShipmentDetails } from '../components/details/shipment-details';

function LaneDetailsForm({ laneId }: { laneId: number }) {
	const { data } = useFetchLane(laneId);
	const router = useRouter();

	if (!data) {
		router.navigate({ to: '/lanes' });
		return null;
	}

	return (
		<LaneDetailContext.Provider value={data.data}>
			<Helmet title={data.data.reference} />
			<ShipmentDetails />
			<ContainerDetails />
			<RouteDetails />
		</LaneDetailContext.Provider>
	);
}

export function LaneDetails() {
	const { t } = useTranslation();
	const { laneId: id } = useParams({ from: '/_protected/lanes/$laneId' });
	const router = useRouter();

	if (!id) {
		router.navigate({ to: '/lanes' });
	}

	return (
		<>
			<Helmet
				title={t('pages.lanes.details.title', 'Lane details').toString()}
			/>
			<Page
				backButton={{
					label: t('pages.lanes.back', 'Back'),
					href: '..',
				}}
				title={t('pages.lanes.details.title', 'Lane details').toString()}
				className="m-auto md:max-w-[550px]"
			>
				<Suspense fallback={<LoadingSpan />}>
					<LaneDetailsForm laneId={id} />
				</Suspense>
			</Page>
		</>
	);
}
